const PASTEL_COLORS = [
  "#e58899",  // Pastel Pink
  "#9bbff4",  // Pastel Blue
  "#8de98d",  // Pastel Green
  "#A88BD4",  // Pastel Purple
  "#f2b48a",  // Pastel Orange
  "#D48BA8",  // Pastel Rose
  "#91ecc9",  // Pastel Mint
  "#D4C08B",  // Pastel Cream
  "#A88BD4",  // Pastel Lavender
  "#D48B8B",  // Pastel Salmon
  "#B8D48B",  // Pastel Lime
  "#8BD4D4",  // Pastel Cyan
  "#D4B88B",  // Pastel Peach
  "#A88BD4",  // Pastel Lilac
  "#D48BB8",  // Pastel Blush
  "#8BC8D4",  // Pastel Sky
  "#C88BD4",  // Pastel Orchid
  "#8BD4A8",  // Pastel Seafoam
  "#D4A88B",  // Pastel Apricot
  "#A88BD4",  // Pastel Periwinkle
]

export function getAvatarColor(name: string): string {
  let hash = 0
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash)
  }
  const index = Math.abs(hash) % PASTEL_COLORS.length
  return PASTEL_COLORS[index]
}
